import { MainApi } from "./MainApi";

export class TestHistoryApi {
  static baseUrl = `${MainApi.urlPrefix}/user/test-history`;

  static getTestHistoryCount = () => () => MainApi.api.get(`${TestHistoryApi.baseUrl}/count?unit_voucher_type=DCAS`);
}
